export default __webpack_public_path__ + "static/Carrossel-Selcionados-e-Consagrados-c013a3ba7e6cf7778b6aec091e988ac6.webp";